module.exports = __webpack_public_path__ + "static/avatar.3e191ca9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/jpg/avatar.jpg
// module id = 191
// module chunks = 114276838955818 198517197184460